import Vue from 'vue'
import Router from 'vue-router'
import {routerBeforeEach, routerAfterEach} from '@/config/interceptors/router'
import courseRouter from './course'
import userCenterRouter from './user-center'
import playRouter from './play'
import qusetionnaireRouter from './qusetionnaire'
import exam from './exam'
import teacherRouter from './teacher'
import classRouter from './class'
import onLineRouter from './on-line'
import resourcesRouter from './resources'
import noticeRouter from './notice'
const retrieve = () => import('@/page/retrieve/retrieve')
const resetPasswords = () => import('@/page/resetPasswords/resetPasswords') // 修改密码路由
const resetPhone = () => import('@/page/resetPhone/resetPhone') // 修改手机号路由
const bindPhone = () => import('@/page/bindPhone/bindPhone') // 绑定手机号路由
const login = () => import('@/page/login/login')
const index = () => import('@/page/index')
Vue.use(Router)
export const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/index',
    name: 'index',
    component: index
  },
  {
    path: '/retrieve',
    name: 'retrieve',
    component: retrieve
  },
  {
    path: '/resetPasswords',
    name: 'resetPasswords',
    component: resetPasswords
  },
  {
    path: '/resetPhone',
    name: 'resetPhone',
    component: resetPhone
  },
  {
    path: '/bindPhone',
    name: 'bindPhone',
    component: bindPhone
  },
  ...courseRouter,
  ...userCenterRouter,
  ...playRouter,
  ...qusetionnaireRouter,
  ...teacherRouter,
  ...exam,
  ...resourcesRouter,
  ...classRouter,
  ...onLineRouter,
  ...noticeRouter
]
const routerInstance = new Router({
  routes: routes
})
routerInstance.beforeEach(routerBeforeEach)
routerInstance.afterEach(routerAfterEach)
export default routerInstance


// WEBPACK FOOTER //
// ./src/router/index.js